export default {
    linkList: {
        "companyLink": "À propos",
        "termsOfService": "Conditions d’utilisation",
        "privacyPolicy": "Politique de confidentialité",
        "guaranteeOfRights": "Droit des personnes concernées par les données",
        "customerSupport": "SERVICE CLIENT",
        "cookiePolicy": "Politique en matière de cookies",
        "declarationOfSafety": "Sécurité・Déclaration sur la sécurité",
        "youthProtectionPolicy": "Politique de protection des jeunes",
        "communityPolicy": "Politique communautaire",
        "operationPolicy": "Politique de gestion",
        "doNotSell": "Ne pas vendre mes informations personnelles",
        "gameGrade": "게임이용등급",
        "communityPolicyView": "커뮤니티정책",
        "servicePolicy": "서비스정책",
        "termsOfUse": "회원정책",
        "operationPolicyNCJ": "운영방침",
        "reportRightsInfringement": "권리침해신고",
    },
    footerWords: {
        "gameRelatedLaw": "Informations supplémentaires à propos des lois sur les jeux",
        "brandInformation": "Informations sur le nom de notre entreprise",
        "copyright": "Copyright",
        "channelingInfo": "NCSOFT a pour fonction de faciliter la vente en ligne de jeux au sein de plaync, et ne commercialise aucun des jeux susmentionnés.<br>Toutes les obligations et responsabilités associées aux jeux fournis incombent à la partie responsable de la vente en ligne, et nous ne pouvons être tenus responsables des éventuels problèmes concernant les jeux en question.",
    },
    infoCS: {
        "businessInformation": "Consulter les informations sur l'entreprise",
        "infoAddress": "Nom de l'entreprise : NCSOFT Corporation ; PDG : Kim Taek-Jin ; numéro d'enregistrement de l'entreprise : 144-85-04244 ; inscription au commerce électronique : 2013-Gyeonggi Seongnam-1268",
        "mobile": "Adresse : 12, 644beon-gil, Daewangpangyo-ro, Bundang-gu, Seongnam-si, Gyeonggi-do, République de Corée. Service client : +82 1566 7004. Fax : +82 02 2186 3499.",
        "pc": "주소 경기도 성남시 분당구 대왕판교로 644번길 12 고객상담 1600-0020 팩스 02-2186-3558",
        "other": "Adresse : 12, 644beon-gil, Daewangpangyo-ro, Bundang-gu, Seongnam-si, Gyeonggi-do, République de Corée. Service client : +82 1600 0020 (Jeux PC), +82 1566 7004 (jeux mobiles). Fax : +82 02 2186 3550 (Jeux PC), +82 02 2186 3499 (jeux mobiles).",
        "none": "",

        "infoEmail": "Adresse e-mail",
        "infoEmail-mobile": "MobileCS@ncsoft.com",
        "infoEmail-pc": "credit@ncsoft.com",
        "infoEmail-other": "credit@ncsoft.com/(PC Game)/MobileCS@ncsoft.com/(Mobile Game)",
        "infoEmail-none": "",
    },
    infoJP: {
        "jpTitle": "Titre",
        "jpGenre": "Genre",
        "jpPrice": "Prix",
        "jpPriceValue": "Jeu gratuit (contient des achats via l’application)",
        "jpOs": "Systèmes d’exploitation compatibles",
        "jpDevelopedBy": "Développeur/Éditeur",
        "jpReleaseDay": "Date de sortie",
        "jpReleaseDayValue_LW": "4 novembre 2021",
    },
    country: {
        "KR": "Corée, République de",
        "TW": "Taïwan",
        "RU": "Russie",
        "MY": "Malaisie",
        "SA": "Arabie Saoudite",
        "SG": "Singapour",
        "AE": "Émirats arabes unis",
        "ID": "Indonésie",
        "JP": "Japon",
        "QA": "Qatar",
        "TH": "Thaïlande",
        "PH": "Philippines",
        "HK": "Hong Kong",
        "UA": "Ukraine",
        "BY": "Biélorussie",
        "LT": "Lituanie",
        "PL": "Pologne",
        "GR": "Grèce",
        "IL": "Israël",
        "KW": "Koweït",
        "AT": "Autriche",
        "US": "États-Unis d’Amérique",
        "CA": "Canada",
        "DE": "Allemagne",
        "GB": "Royaume-Uni",
        "FR": "France",
        "BR": "Brésil",
        "IT": "Italie",
        "ES": "Espagne",
        "CL": "Chili",
        "NO": "Norvège",
        "SE": "Suède",
        "IE": "Irlande",
        "PT": "Portugal",
        "FI": "Finlande",
        "DK": "Danemark",
        "CH": "Suisse",
        "AR": "Argentine",
        "PE": "Pérou",
        "MX": "Mexique",
        "KZ": "Kazakhstan",
        "UZ": "Ouzbékistan",
        "AZ": "Azerbaïdjan",
        "GE": "Géorgie",
        "MD": "Moldavie",
        "AM": "Arménie",
        "MO": "Macao",
        "IN": "Inde",
        "PK": "Pakistan",
        "NL": "Pays-Bas",
        "RO": "Roumanie",
        "AU": "Australie",
        "TR": "Turquie",
        "EC": "Équateur",
        "CO": "Colombie",
        "ZA": "Afrique du Sud",
        "EG": "Égypte",
        "NC": "Mondial",
    },
}
